import { render, staticRenderFns } from "./settleModel.vue?vue&type=template&id=baf25ce8&scoped=true&"
import script from "./settleModel.vue?vue&type=script&lang=js&"
export * from "./settleModel.vue?vue&type=script&lang=js&"
import style0 from "./settleModel.vue?vue&type=style&index=0&id=baf25ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf25ce8",
  null
  
)

export default component.exports